<template>
  <div class="avatar-box">
    <toolTip v-if="showToolTip" :show="true" :maxWidth="width" :title="userName">
      <div class="my-avatar" :style="{'width':width,'height':height,'lineHeight':height,'fontSize':size}">
        <div v-if="isShowImage && imgUrl" class="my-avatar-img" :style="{'fontSize':size, 'lineHeight': 0}">
          <img ref="headImage" :src="imgUrl" @error="isShowImage = false">
        </div>
        <div v-else class="my-avatar-txt" :style="{'fontSize':size}">{{name}}</div>
      </div>
    </toolTip>
    <div v-else class="my-avatar" :style="{'width':width,'height':height,'lineHeight':height,'fontSize':size}">
      <div v-if="isShowImage && imgUrl" class="my-avatar-img" :style="{'fontSize':size, 'lineHeight': 0}">
        <img ref="headImage" :src="imgUrl" @error="isShowImage = false">
      </div>
      <div v-else class="my-avatar-txt" :style="{'fontSize':size}">{{name}}</div>
    </div>
    <span class="name-txt" v-if="this.$slots.default">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: "myAvatar",
  props: {
    showToolTip:{
      type: Boolean,
      default: true
    },
    userName: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: '32px'
    },
    height: {
      type: String,
      default: '32px'
    },
    size: {
      type: String,
      default: '12px'
    },
  },
  data() {
    return {
      isShowImage: true
    }
  },
  mounted() {
  },
  watch: {
    imgUrl() {
      this.isShowImage = this.imgUrl !== ""
    }
  },
  computed: {
    name() {
      return this.userName.slice(-2);
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.avatar-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .name-txt {
    margin-left: 8px;
    color: inherit;
  }
}
.my-avatar {
  flex-shrink: 0;
  border: 1px solid #ffffff;
  border-radius: 50%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.my-avatar-img,
.my-avatar img,
.my-avatar .my-avatar-img img {
  width: 100%;
  height: 100%;
}
.my-avatar-img img {
  vertical-align: -8px;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}
.my-avatar-txt {
  background: #E7E9EC;
  @include fontColorOpacity(.6);
  font-size: 12px;
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>
